import { useState } from 'react';
import { CompetitionExerciseTypeClient, CompetitionExerciseTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useCompetitionExerciseTypeApi = () => {
    const apiClient = new CompetitionExerciseTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: CompetitionExerciseTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createCompetitionExerciseType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating CompetitionExerciseType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: CompetitionExerciseTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateCompetitionExerciseType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating CompetitionExerciseType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getCompetitionExerciseTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching CompetitionExerciseType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchCompetitionExerciseTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching CompetitionExerciseTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteCompetitionExerciseType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting CompetitionExerciseType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};